/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAILURE,
  SAVE_TRANSACTIONS,
  SAVE_TRANSACTION,
  SAVE_TRANSACTIONS_SUCCESS,
  SAVE_TRANSACTIONS_FAILURE,
  GET_TRANSACTIONS_FROM_BANK,
  GET_TRANSACTIONS_FROM_BANK_SUCCESS,
  GET_TRANSACTIONS_FROM_BANK_FAILURE,
  UPDATE_TRANSACTION,
  UPDATE_TRANSACTION_FAILURE,
  UPDATE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_FAILURE,
  DELETE_MULTI_TRANSACTION,
  DELETE_MULTI_TRANSACTION_SUCCESS,
  DELETE_MULTI_TRANSACTION_FAILURE,
  GET_NOTIFICATIONS,
  DOWNLOAD_SAMPLE_CSV,
  MARK_ALL_PAID,
  REMOVE_ALL_DUPLICATES,
  DOWNLOAD_PAST_SAMPLE_XLSX,
  GET_ASSET_CHECKLIST,
  GET_ALL_TRANSACTIONS,
  GET_ALL_TRANSACTIONS_SUCCESS,
  GET_ALL_TRANSACTIONS_FAILURE
} from "../actions/actionTypes";
import { saveFile } from "../helpers";

import handleFailedAuth from "../helpers/handleExpiredToken";

import { Transaction } from "../api/agent";
import showToast from "../helpers/toastNotification";

function* getAllTransactions(action) {
  try {
    const payload = yield call(Transaction.getAllTransactions, action.payload);
    yield put({ type: GET_ALL_TRANSACTIONS_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = error.response.body;
    yield put({ type: GET_ALL_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchGetAllTransactions() {
  yield takeLatest(GET_ALL_TRANSACTIONS, getAllTransactions);
}

function* getTransactions(action) {
  try {
    const payload = yield call(Transaction.getTransactions, action.payload);
    yield put({ type: GET_TRANSACTIONS_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = error.response.body;
    yield put({ type: GET_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchGetTransactions() {
  yield takeLatest(GET_TRANSACTIONS, getTransactions);
}

function* getTransactionsFromBank(action) {
  try {
    const payload = yield call(
      Transaction.getTransactionsFromBank,
      action.payload
    );
    yield put({ type: GET_TRANSACTIONS_FROM_BANK_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = error.response.body;
    yield put({ type: GET_TRANSACTIONS_FROM_BANK_FAILURE, errResp });
  }
}

export function* watchGetTransactionsFromBank() {
  yield takeLatest(GET_TRANSACTIONS_FROM_BANK, getTransactionsFromBank);
}

//Save transactions
function* saveTransactions(action) {
  try {
    const slug = action.payload.slug;
    const payload = yield call(Transaction.saveTransactions, action.payload);
    yield put({ type: SAVE_TRANSACTIONS_SUCCESS, payload });
    yield put({ type: GET_ASSET_CHECKLIST, payload: slug });
    showToast("s", "Transaction Saved Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Save Transaction");

    const errResp = error.response.body;
    yield put({ type: SAVE_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchSaveTransactions() {
  yield takeLatest(SAVE_TRANSACTIONS, saveTransactions);
}

//Save single transaction
function* saveTransaction(action) {
  try {
    const slug = action.payload.slug;
    const payload = yield call(Transaction.saveTransaction, action.payload);
    yield put({ type: SAVE_TRANSACTIONS_SUCCESS, payload });
    yield put({ type: GET_ASSET_CHECKLIST, payload: slug });
    showToast("s", "Transaction Saved Successfully");
  } catch (error) {
    console.log("ERROR:", error);
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Save Transaction");

    const errResp = error.response.body;
    yield put({ type: SAVE_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchSaveTransaction() {
  yield takeLatest(SAVE_TRANSACTION, saveTransaction);
}

//Update transaction
function* updateTransaction(action) {
  try {
    const payload = yield call(Transaction.updateTransaction, action.payload);
    yield put({ type: UPDATE_TRANSACTION_SUCCESS, payload });
    yield put({ type: GET_NOTIFICATIONS });
    showToast("s", "Transaction Updated Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Update Transaction");
    const errResp = error.response.body;
    yield put({ type: UPDATE_TRANSACTION_FAILURE, errResp });
  }
}

export function* watchUpdateTransaction() {
  yield takeLatest(UPDATE_TRANSACTION, updateTransaction);
}

//Delete transaction
function* deleteTransaction(action) {
  try {
    const slug = action.payload.slug;
    const payload = yield call(Transaction.deleteTransaction, action.payload);
    yield put({ type: DELETE_TRANSACTION_SUCCESS, payload });
    yield put({ type: GET_NOTIFICATIONS });
    yield put({ type: GET_ASSET_CHECKLIST, payload: slug });
    showToast("s", "Transaction Deleted Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Delete Transaction");

    const errResp = error.response.body;
    yield put({ type: DELETE_TRANSACTION_FAILURE, errResp });
  }
}

//Delete multi transaction
function* deleteMultiTransaction(action) {
  try {
    const slug = action.payload.slug;
    const payload = yield call(
      Transaction.deleteMultiTransaction,
      action.payload
    );
    yield put({ type: DELETE_MULTI_TRANSACTION_SUCCESS, payload });
    yield put({ type: GET_NOTIFICATIONS });
    yield put({ type: GET_ASSET_CHECKLIST, payload: slug });
    showToast("s", "Transaction Deleted Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Delete Transaction");

    const errResp = error.response.body;
    yield put({ type: DELETE_MULTI_TRANSACTION_FAILURE, errResp });
  }
}

export function* watchDeleteTransaction() {
  yield takeLatest(DELETE_TRANSACTION, deleteTransaction);
}

export function* watchMultiDeleteTransaction() {
  yield takeLatest(DELETE_MULTI_TRANSACTION, deleteMultiTransaction);
}

function* downloadSampleCSV(action) {
  try {
    const fileData = yield call(Transaction.downloadSampleCSV, action.payload);
    saveFile(fileData, "transaction_import.csv");
  } catch (error) {}
}

export function* watchDownloadSampleCSV() {
  yield takeLatest(DOWNLOAD_SAMPLE_CSV, downloadSampleCSV);
}

function* downloadPastSampleXLSX(action) {
  try {
    const fileData = yield call(
      Transaction.downloadPastSampleXLSX,
      action.payload
    );
    saveFile(fileData, "past_transaction_import.xlsx");
  } catch (error) {}
}

export function* watchdownloadPastSampleXLSX() {
  yield takeLatest(DOWNLOAD_PAST_SAMPLE_XLSX, downloadPastSampleXLSX);
}

function* markAllPaid(action) {
  try {
    const payload = yield call(Transaction.markAllPaid, action.payload);
    yield put({ type: GET_TRANSACTIONS_SUCCESS, payload });
    showToast("s", "All Transactions are Mark Paid");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Perform Operation");

    // const errResp = error.response.body;
    // yield put({ type: SAVE_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchMarkAllPaid() {
  yield takeLatest(MARK_ALL_PAID, markAllPaid);
}

function* removeAllDuplicates(action) {
  try {
    const payload = yield call(Transaction.removeAllDuplicates, action.payload);
    yield put({ type: GET_TRANSACTIONS_SUCCESS, payload });
    showToast("s", "Duplicate Transaction Removed Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Perform Operation");

    // const errResp = error.response.body;
    // yield put({ type: SAVE_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchRemoveAllDuplicates() {
  yield takeLatest(REMOVE_ALL_DUPLICATES, removeAllDuplicates);
}
